"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollWrapper = exports.CategoryNav = exports.CategoryButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("../../theme"));
var _categoryNavigationButton = _interopRequireDefault(require("../../styles/categoryNavigationButton"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ScrollWrapper = exports.ScrollWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled-components__ScrollWrapper",
  componentId: "sc-3fm2g0-0"
})(["display:flex;grid-column:1 / 13;overflow-x:scroll;overflow-y:hidden;white-space:nowrap;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}"]);
var CategoryNav = exports.CategoryNav = _styledComponents["default"].nav.withConfig({
  displayName: "styled-components__CategoryNav",
  componentId: "sc-3fm2g0-1"
})(["display:flex;justify-content:space-between;padding:5px ", ";", " ", " > a:first-child{margin-left:0;}"], _theme["default"].spacingM, _theme["default"].mediaMediumPlus(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      padding: 5px ", ";\n  "])), _theme["default"].spacing2XL), _theme["default"].mediaLargePlus(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      padding: 5px ", ";\n  "])), _theme["default"].spacing2XL));
var CategoryButton = exports.CategoryButton = _styledComponents["default"].a.withConfig({
  displayName: "styled-components__CategoryButton",
  componentId: "sc-3fm2g0-2"
})(["", ""], _categoryNavigationButton["default"]);